<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize
                        d-flex
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "Products",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        tabs() {
            let tabs = [
                {
                    name: { el: "Προϊόντα", en: "products", it: "Prodotti" },
                    to: `/${this.lang}/loyaltyPanel/products/products-tab`,
                },
                {
                    name: {
                        el: "Προϊόντα ανά κατάστημα",
                        en: "products per store",
                        it: "Prodotti per negozio",
                    },
                    to: `/${this.lang}/loyaltyPanel/products/products-per-store`,
                },
            ]
          
               
                if (this.getPermission('products.order')) {
                    tabs.push({
                    name: {
                        el: "Σειρά Προϊόντων ",
                        en: "product order",
                        it: "Gamma di prodotti",
                    },
                    to: `/${this.lang}/loyaltyPanel/products/products-series`,
                })
            }
            if (this.getPermission('products.tag.read')) {
                tabs.push(
                {
                    name: {
                        el: "Ετικέτες Προϊόντων",
                        en: "products tags",
                        it: "Etichette del prodotto",
                    },
                    to: `/${this.lang}/loyaltyPanel/products/products-tags`,
                })
            }
            return tabs
        },
    },
    methods: {
        ...mapActions(["getPermission"])
    },

    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/products`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/products/products-tab?page=1`
                    );
                }
            },
        },
    },
};
</script>
